var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47162 15.5389C3.17678 15.244 3.17678 14.766 3.47162 14.4711L11.4716 6.47114C11.7665 6.1763 12.2445 6.1763 12.5394 6.47114L20.5394 14.4711C20.8342 14.766 20.8342 15.244 20.5394 15.5389C20.2445 15.8337 19.7665 15.8337 19.4716 15.5389L12.0055 8.07274L4.53935 15.5389C4.24451 15.8337 3.76647 15.8337 3.47162 15.5389Z",
    fill: "#00322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.58a39e6709b18e95de645baa29771818.svg";
export { ForwardRef as ReactComponent };